/* istanbul ignore file */

import { GridAction } from '../shared/enums';
import { FieldIdentifier } from './field-identifier';
import { KHFileInfo } from './kh-file-info';
import { SelectableField } from './selectable-field';

export class SiteActivityLog {
    oldFieldValue: any;
    newFieldValue: any;
    fieldIdentifier: FieldIdentifier;
    selectableField: SelectableField;
    rowIdentifierValue = "";
    modifiedBy: string;
    timestamp?: Date;
    siteId: string;
    appId: string;
    projectId: string;
    rowId: string;
    gridAction: GridAction = GridAction.None;
}

export class SiteActivityLogViewModel extends SiteActivityLog {
    textAreaInnerTextChange: string;
    allFiles: KHFileInfo[];
    addedFiles: KHFileInfo[];
    deletedFiles: KHFileInfo[];
    allUsers: string[];
    addedUsers: string[];
    deletedUsers: string[];
    originalRowIdentifierValue?: string;

    constructor(siteActivityLog: SiteActivityLog) {
        super();
        Object.assign(this, siteActivityLog);
    }
}
